let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7GCHJ")).then(() => parcelRequire('7Ri80'));